var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTickartsOfficiel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #b4283f;\n      }\n\n      .st1 {\n        fill: #c41622;\n      }\n\n      .st2 {\n        fill: #b91a34;\n      }\n\n      .st3 {\n        fill: #bb1b32;\n      }\n\n      .st4 {\n        fill: #be1f2e;\n      }\n\n      .st5 {\n        fill: #0c0607;\n      }\n\n      .st6 {\n        fill: #c80b13;\n      }\n\n      .st7 {\n        fill: #c80d14;\n      }\n\n      .st8 {\n        fill: #bc1d31;\n      }\n\n      .st9 {\n        fill: #c90a13;\n      }\n\n      .st10 {\n        fill: #c12a2e;\n      }\n\n      .st11 {\n        fill: #c71318;\n      }\n\n      .st12 {\n        fill: #c91114;\n      }\n\n      .st13 {\n        fill: #c22429;\n      }\n\n      .st14 {\n        fill: #c90c13;\n      }\n\n      .st15 {\n        fill: #be1e2e;\n      }\n\n      .st16 {\n        fill: #c81115;\n      }\n\n      .st17 {\n        fill: #0d0708;\n      }\n\n      .st18 {\n        fill: #c91014;\n      }\n\n      .st19 {\n        fill: #090504;\n      }\n\n      .st20 {\n        fill: #c80c13;\n      }\n\n      .st21 {\n        fill: #c80c14;\n      }\n\n      .st22 {\n        fill: #ba1c33;\n      }\n\n      .st23 {\n        fill: #c51a1f;\n      }\n\n      .st24 {\n        fill: #c61b1d;\n      }\n\n      .st25 {\n        fill: #bb1c32;\n      }\n\n      .st26 {\n        fill: #c81217;\n      }\n\n      .st27 {\n        fill: #090505;\n      }\n\n      .st28 {\n        fill: #c71519;\n      }\n\n      .st29 {\n        fill: #be202e;\n      }\n\n      .st30 {\n        fill: #ba2235;\n      }\n\n      .st31 {\n        fill: #0b0607;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M139.9,252.7c.4.6.9,1.6.5,2-1.7.6-4,.5-5.7-.3s-5.2-7.3-8.6-10.3-2,0-2.6.8c-2.3,2.8-1.2,7.1-1.7,10.1h-6.3s0-28.9,0-28.9h6.4c0,0,.2,12.8.2,12.8l10.3-10.9c1-1,2.1-1.7,3.5-2,1.6.1,3.1,0,4.8.5l-6.8,7.4c-1.4,1.5-2.8,3-3.5,5l9.5,13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M88.6,246.6c1.9,2.1,5,3.4,7.8,3.1s6-4,8.3-1.2.9.9,1,1.5c.4,3.8-14.6,10-22.6-.6-3.6-4.8-3.9-11.3-.8-16.5s8.4-8,14.2-7.5,5.6,1.7,8,3.2-.4,4-1.6,5.5c-4.3-1.7-5.5-3.8-10-2.5s-6.2,4-6.3,8.1.1,4.9,1.9,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M46.6,254.9c-2.1.4-4.1.2-6-.4-.3-2-.4-3.9-.4-6v-16.6c0,0-8.8,0-8.8,0,0-2-.2-3.9,0-5.8h23.9c.2,2,0,3.7,0,5.7l-8.8.2v23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M214.3,253.4l-6.7-9.4h-8s-.2,10.8-.2,10.8c0,.5-1.9.5-1.9,0v-27.9c4.7.3,9.4-.3,14.2.5s4.9,3.8,5.8,6.4c.3,4.2-2,7.7-5.6,9.5s-.9.8-.5,1.3l6,9.6c-1.1.9-2.4.3-3.1-.8ZM214.9,235.9c.2-4-2.6-6.4-6.2-6.4h-8.7s0,12.1,0,12.1c3.7-.1,7.3.2,10.9-.6s3.6-3,4-5.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st19",
    x: 64.8,
    y: 226,
    width: 5.8,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M264.9,253.9c-5.1,2-11,.9-14.8-2.9,0-.8.9-1.6,1.6-1.9,3,2.7,7.1,4.1,10.9,3s3.8-2.7,3.6-5.3-.6-2.6-2.2-3.2l-9.1-3.4c-2-.7-3.4-2.2-4-4.2-1.1-4,1.4-8,5.4-9.1s11.7.9,11.2,3.2-3.2-1.4-8.2-1.2-4.4,1.2-5.6,2.9-.2,5.1,2.2,6l8.3,3c3.3,1.2,4.7,4,4.4,7.4s-1.2,4.7-3.8,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M177.1,231.2c-4.2,7.6-6.9,15.3-10.3,22.9s-2.1.7-2.7.3l11.1-25.8c.3-.8.9-1.4,1.5-1.5.9,0,1.6.4,2,1.3l10.6,25.8c-.3.6-1.2.5-1.8.4s-.8-.8-1.2-1.5l-9.2-21.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M235.1,254.1c0,1-2.1,1-2.2.4-.2-1.6-.3-3.4-.3-5v-20.3c0,0-8.7-.1-8.7-.1-.5,0-.5-1.8,0-1.9h20.3c.6,0,.6,1.7.1,1.8-2.8.4-5.9,0-9.1.1v25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st31",
    x: 152.8,
    y: 221.6,
    width: 1.4,
    height: 37.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.6,249.1c-2.7.8-5.1.2-7.8.1.4-1.6,1.2-2.8,1.9-4.2,1.5-.2,2.8-.2,4.3,0,.9,1.1,1.5,2.4,1.6,4.1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M61.8,107.8c.4,1.8-3.9-.8-7.4-1.6l-7.9-1.8c-1.1-.2-2.9-2.9,4.5-.2s6.5,2.4,10.1,2.8.7.6.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M45.8,75.7c.5.2.7.4.7.7,0,.5-.5.7-1,.4l-2.7-1.4c.2.1-7.9-2.4-6.8-3.4s5.8,2.3,7.1,2.8l2.7,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M41.8,48.8c-1.4.9-3.9-2-2.8-3.4s2.3-.1,2.7.5,1.2,2.2.1,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61,96.7c.2,1.2-1.1,1.1-1.8,1s-1.2-1.3-.6-2,2.2-.1,2.4,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.7,58.1c-.4.8-2.4-.5-1.8-1.3s2.1.5,1.8,1.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 49.4,
    cy: 71.3,
    r: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 55.6,
    y: 49.4,
    width: 0.9,
    height: 2.1,
    transform: "translate(-19.2 56) rotate(-46.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st29",
    cx: 83.9,
    cy: 61.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 49.8,
    y: 52.7,
    width: 0.9,
    height: 1.5,
    transform: "translate(-23.1 56.6) rotate(-49.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st25",
    x: 59.7,
    y: 54.4,
    width: 0.8,
    height: 1.5,
    transform: "translate(-21.4 52.4) rotate(-40.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 51.5,
    cy: 79,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 63.6,
    cy: 101.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 64.9,
    y: 62.6,
    width: 0.8,
    height: 1.2,
    transform: "translate(-25.6 64.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M72.3,60c0,.9-.8.9-.8,0s.8-.5.8,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M116.4,133.5c-.5-.6-1.5-.4-2.3-.3l-12.2,1.5c-1.8-.3-3.5-1.8-5.3-2.4-4.1-1.3-8,0-12.1-1.1,2.6-1.1,16.9-1.4,17.5-3.1s-12.6-2-11.5-6.2,7.8-2.4,9.7-2.4,3.1.9,4.7,1.1c7.6,1,22.5,1.8,30.3.2l-7.6-5.1h-20c-4.7,0-9.2.5-13.9,0s-6-2.1-8.8-3.2-3.8-3-5.6-4.6c-4.4-3.9-4.4,1.8-8.1-1.2s-1.9-2.1-1-3.3,3.1-1.6,4.9-1.1c3.8.9,7.6,1.1,11.5.6-3.1-2.7-6.1-4.7-9.2-7.1s-2.4-2.8-4-3.6c-2.2-1.2-3.6-2.7-5.2-4.5s-3.8-1.6-5.3-3.1c.8-.8,5,2.8,6.8,1.7-1.3-2.2-3.4-3.2-5.1-4.7-4-3.4-8,0-8.5-3s-1.3-2.3-1.9-4.1c1.8,1.1,3.4,1.6,4.8.1-3.9-5.6-9.2-9.6-13.2-15.2.5-.8,1.4-.2,1.8.2l5.7,4.6c4.8,3.9,10.6,6.1,16.2,8.9l34.9,17.5c5.8,2.9,11.2,5.9,17,9.3-1.3-2.7-3.6-4-5.6-5.8-5.6-5.1-13-8.5-15.8-15.4,2.3,1.2,4,2.8,5.9,4.4l12.6,11.3c3.8,3.4,6.7,7.7,9.2,12.1s.5,2,1.8,1.8,2.1-.8,1.3-1.9c-2.2-2.8-5.2-5-6.3-8.9,6.1,2.6,11.5,5.3,16.8,8.6s8.5,6.4,11.2,11.1,2.8,11.9-.4,16.8-8.2,10.2-13.2,14.7c-1.1-4.1-.5-7.7-.8-11.8-6.3,6.6-11.7,21.2-14.8,30s-1.5,4.9-2.8,7.1-2.9,3-3.2,5.2c1.1.2,1.8-1,3-.6-6.8,13.4-13.9,25-26.7,33.3l9.4-14.6c9.3-14.5,15.1-38.3,22.3-51.2s7.1-9.2,11.8-12.4,4.2-1.8,6.1-3.7c-5.6-.4-10.8,1.7-15.2,5s-3.9,2.7-5.9,4c-3.6,2.4-6.5,7.1-11.4,6.3s-2.7-.2-4-.6c0-5.6,4.5-8.4,9.2-11.1ZM120.3,101.8c-3.5-2.5-7-4.7-11.1-6-6.7-2-13.4-3-20.3-3.5s-1.1.2-.9.6c.7,1.2,10.7,5.1,12.9,5.9,7.9,2.7,15.6,5,23.9,7.1-1-2-2.8-2.9-4.5-4.1ZM121.4,108.2c-5.4-2.5-23.9-4.3-31-4,11.9,6.8,25.4,8.1,38.3,10.3,3.9,0-6.8-6-7.3-6.3ZM138.8,112.1c-.2-.8-2.3-1.1-2.5-.4-.4,1.2.7,2.3,1.5,2.8,4.7,3.3,3,6.1,5,6.5s1-.2,1-.6c0-3.1-3.5-1.8-5.1-8.3ZM139.8,126.9c-3.5-4.1-12.2-2.5-16.9-1.7l-17.8,3.2c11.4,4.8,23.6,2.3,34.8-1.6ZM147.4,130.7c.5.8,1.8.4,2.4,0s.6-1.3.2-2.1-1.3-1.4-2.1-.8-.9,2.1-.5,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M138.8,194.2c5.2.8,10,.5,15,.7s8.3-.5,12.4-1.7c10-2.8,18.6-8.1,25.9-15.4,5.2-5.2,9.3-10.7,12.6-17.2,6-11.6,9.1-23.9,9.5-37s-.9-18.4-3.7-27.3-.6-2.2-.4-3.1c1.7-1,3.5-1.7,5.8-2.2,8.4,24.4,6.6,50.3-5.6,73.1-6,11.2-14.5,20.6-25.2,27.4-6.9,4.4-14.3,7.6-22.5,9s-20.2,1.4-26.4-1c.6-2,1.5-3.2,2.5-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M143.7,156.4c.3-.2.6-.2,1,0l7.7,2.4c1.1-.8,2.7-.8,3.7-1.8,3.2-4,5.7-8.3,8.5-12.5s.5-.7.8-.9c.2-.3.3-.2.4,0,.4.3.6.7.3,1.1l-7.5,11.9c8.4-4,15.3-11,19-19.5s-1.7-8.7-2.6-10.6c-1,2.3-1.9,4.5-2.9,6.8h-.9s-.1-.3-.1-.3c-.4-.1-.8-.4-.6-.8.9-2.4,1.6-4.7,2.2-7.1,0-.6,0-.9-.7-1.2-1.8-.8-6.5-1.3-8.2-.9.9,3.4,2,6.7,3.2,10l-.6.7c0,.3-.2.3-.3,0-1.5-1.8-2.8-7.2-4.6-10.2-1,2.2-1.4,4.4-2.2,6.6-1.7,5-4.8,9.7-9.7,12.2l5.6-6c3.2-3.4,4.6-8.5,4.9-13.2s-1.2-1.7-.7-2.4c2.1-3.7,1.6-.2,4.2-3.4s3.5-5.2,6-7.5c-.5,2.2-6.1,8.8-6.1,10.1s11.1,3.2,10.6.2l-1.7-10.5c0-.7.2-.7.4,0,.6-.4.9-.2,1,.4.6,3.4,1.3,6.7,2.3,9.9,2-1.4,4.1-3.5,5.5-5.6-1.9-1.5-3.9-3-5.9-4.5l.2-.8c0-.3,0-.3.3,0l.6-.4,6.4,3.6c1.3-7.2,4.5-13.9,9.2-19.6-5.5,3.3-10.6,7-15.5,11.2l-1.5.3c-.6,0-.7-.2-.1-.5,5.7-5.4,12-10,19.1-13.7s7.3-6.1,11.3-7.3c7.1-2,14-3.7,21.3-5.1,5.8-.8,11.3-1.9,17.3-.6-8.1,1.4-15.5,3.1-23,5.7-12.6,4.7-20.5,6.3-27.9,18.1-2.4,3.8-3.7,8-4.6,12.4l-3.1,16.5c-2.8,15.2-12.5,27.7-27.4,32.6l-15.2,5.2c-4.9,1.7-9.3,3.8-14.1,6.4,3.2-4.3,7.7-6.8,12.4-8.9l11-4.9c-1.8-1.6-7.9-2.4-8.7-3.6ZM179.5,134c1.9-6.3,2.8-12.1,3.4-18.2-3,2.3-6.9,6.5-6.1,10.1s1.2,5.6,2.7,8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M200.2,72.9c-4.4-6-9.6-11-15.7-15.2-10.8-7.6-23.6-11-36.8-10.5s-22.4,3.8-32.5,9.4c-1.6-1.2-2.7-2.5-4.1-4l7.1-3.9c9.9-5.5,21.4-7.9,32.9-7.8,14.5.1,28.1,5.5,39.5,14.1,5.6,4.2,10.2,9.2,14.4,14.8s2.5,3.2,2.4,5.1-2.9,1.9-4,1.4-2.2-2-3.2-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M103.8,185.4c-1,1.4-9.4-7-10.4-8.1-7-7.7-12.5-16.3-16.2-26-2-5.2-3.1-10.5-4.2-15.9,2.3-.4,4.1-.5,6.3-.5,4.4,19.2,11.2,32.9,26.7,45.4-.6,1.8-1.1,3.6-2.2,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M143.9,100.1c-.3,1.1-21.3-10.7-23-11.6-5.1-2.9-9.3-6.4-13.1-11l-13.7-16.8c-.4-.5-.9-1.1-.6-1.8,6.9,4.4,13.3,8.9,19.6,14,10.6,8.6,20.6,17.5,30.6,26.6.2.2.2.5.2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M245.1,108.8c-2.2,2.2-5.7,2.9-8.6,2.1-4.7-1.3-7.4-6.4-6.2-11s2.2-5,3.5-7.5c2-3.9,3.7-7.7,5-12.2,2.4,7.9,4.3,10.1,7.9,16.9,1.6,3.8,1.7,8.5-1.5,11.7ZM233.6,104.8c.2-3.3.4-6.2,1.6-9.3s.8-2.2.8-3.4c-1.8,2.7-6.1,9.3-2.4,12.7ZM240.3,108.8c4,0,6.3-4.5,5.6-7.7-2,5.2-1.5,4.2-5.6,7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M162.8,105.7c-1.5,2.5-3.8,4.4-6.6,4.6s-2.1-.7-2.3-1.8c3.1-1.1,5.4-3.1,6.6-6l4.6-10.9c2.3-5.5,8-10.9,14.3-11.4,3.7-.3,7.5-.5,11.2.6l9.8,2.9c-7.9,4.2-14.4-2.2-22.8,1.9s-7.2,5.6-9.3,9.6-3.4,7-5.6,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M152.6,101.9l-17.5-15.8c-2.9-2.6-5.3-5.2-7.7-8.2-3.4-5.5-5.8-11.6-5-18.5,2.7,6,5.9,11,10.3,15.6l10.8,11.5c4.1,4.4,7.6,9.3,9.1,15.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M108.5,205.3c4-5.1,7.8-9.5,10.9-14.9s8.1-12.1,13.1-14.5c-1.8,4.7-3.3,9-5.5,13.3-3.8,7.4-10.3,13.1-18.5,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.8,72c.7,0,.5-1,1.2-1.3,2.8,7.7,7.8,9,13.2,14l-15.5-6.9c-6.1-2.7-8.9-3.3-11.3-9.4s-2.1-3.5-2.8-5.6l3.4,4c.9,1,1.4,1.9,3,2.1s2.4,1,3.5.3.2-1.2.5-1.7c.9.5.7,1.6,1.1,2.5s2.1,2.1,3.6,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M130.3,194c-.3.5-1.8.4-1.6,0,2-4.4,3.9-8.6,6.3-12.7s4.5-6.9,8.5-8.8c-2,10.6-5.1,15.1-13.1,21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M171.1,133.4c.5.7.5,1.5,0,2.6,2.6,2.8,1.6,7.4-2.2,8.4s-3.4.4-3.3-.8h-.4c-.2-1.9-2.3-.5-3.4-.9,4.4-1.8.7-2.2,4.3-6.1s0-2.1-.2-3h.3c.2-.2.4-.3.7-.2.8,1.6,1.5,2,2.2,1.1.5-.9,1.2-1.4,1.9-1.5v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M143.7,156.4c-5.5-.4-1.5.9-8.2,1.4.1-1.5.3-2.4.6-3.6.7-2.8,3.3-1.4,4.7-2.4s2.5-1.4,4.1-1.3c-1.2,1-4,2.3-3.9,3.6s2.4,1.5,2.8,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M175.2,103.7c0,.2.2.3.1.5.5.5.8,1.3.6,2.4.4,1,.5,1.8.2,2.4,0,0-.2,0-.3,0l-.6.6c-.8,0-1.7,0-2.5,0h-.4c-1-.6-1.9-.3-3.1.6.4-1.3.6-2.1.4-3.3-.3-1.8.8-3.2,2.5-3.3h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M181.9,92.7c-1.8-.5-2.5-2-2.2-3.3s1.2-2.8,2.9-2.6,2.8,1.7,2.7,3.1-1.6,3.3-3.3,2.8ZM183.7,88.7c0-.4-.3-.7-.7-.7s-.7.3-.7.7.3.7.7.7.7-.3.7-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M73.2,126.3c-2.7-1-9.5-.2-8.5-1.3s6.9.3,8.4-.1c1.9-.8,5-1.2,6.4.5s-.8,2.9-6.3,1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 71.6,
    cy: 113.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.9,121.8c-.7,0-.8-.7-.5-.9s.6-.2.9,0c.5.3.6.9-.4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M68.2,66.8c.1-.2.5,0,.8,0s.3.3.2.5-.4.1-.5.2c-.3.1-.7-.2-.4-.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTickartsOfficiel);
export default __webpack_public_path__ + "static/media/logo-tickarts-officiel.ec2797f845ec4fc1b680994df5382605.svg";
export { ForwardRef as ReactComponent };